// События
export const CMD_EVENT = 'player:cmd';       // команды от UI-плеера к BeatItem
export const REG_EVENT = 'beat:register';    // BeatItem → UI: "я есть"
export const UNREG_EVENT = 'beat:unregister';
export const STATE_EVENT = 'beat:state';     // BeatItem → UI: состояние (playing, time, duration)

// Отправка команд
export function sendCmd(type, detail = {}) {
  window.dispatchEvent(new CustomEvent(CMD_EVENT, { detail: { type, ...detail } }));
}

// Хелперы
export const cmdPlay   = (id)               => sendCmd('play',   { id });
export const cmdPause  = (id)               => sendCmd('pause',  { id });
export const cmdToggle = (id)               => sendCmd('toggle', { id });
export const cmdSeek   = (id, seconds)      => sendCmd('seek',   { id, seconds });
export const cmdSeekPct= (id, pct)          => sendCmd('seekPct',{ id, pct }); // 0..100
export const cmdVolume = (id, volume01)     => sendCmd('volume', { id, volume: Math.max(0, Math.min(1, volume01)) });

// Подписки на состояние/регистрацию — использовать в плеере
export const onBeatRegister = (cb) => {
  const h = (e) => cb(e.detail);
  window.addEventListener(REG_EVENT, h);
  return () => window.removeEventListener(REG_EVENT, h);
};
export const onBeatUnregister = (cb) => {
  const h = (e) => cb(e.detail);
  window.addEventListener(UNREG_EVENT, h);
  return () => window.removeEventListener(UNREG_EVENT, h);
};
export const onBeatState = (cb) => {
  const h = (e) => cb(e.detail);
  window.addEventListener(STATE_EVENT, h);
  return () => window.removeEventListener(STATE_EVENT, h);
};

